import { inject } from "@angular/core";
import {
  Router,
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthState } from "../services/auth.state";
import { BYPASS_AUTH } from "../../../../constants";

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  if (BYPASS_AUTH) {
    return true;
  }

  const authState = inject(AuthState);
  const router = inject(Router);

  if (authState.isAuthenticated()) {
    return true;
  }

  const redirectPath = state.url;
  const shouldSaveRedirect =
    redirectPath !== "/" && !redirectPath.startsWith("/login");

  return router.createUrlTree(["/login"], {
    queryParams: shouldSaveRedirect ? { redirectPath } : {},
  });
};

export const permissionGuard = (permissionId: string): CanActivateFn => {
  return () => {
    if (BYPASS_AUTH) {
      return true;
    }

    const authState = inject(AuthState);
    const router = inject(Router);

    if (authState.hasPermissionFor(permissionId)) {
      return true;
    }

    return router.createUrlTree(["/unauthorized"]);
  };
};
